var map = {
	"./de.png": "2a03",
	"./en.png": "b18b",
	"./es.png": "dca1",
	"./fr.png": "6394",
	"./hi.png": "89f1",
	"./ja.png": "7c1b",
	"./ko.png": "3fc9",
	"./pt.png": "57ea",
	"./ru.png": "36c8",
	"./zh-CN.png": "91d1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "77fc";